<mat-select [ngModel]="value" [disabled]="disabled" [placeholder]="placeholder">
  <mat-option *ngIf="!required" [value]="null" (onSelectionChange)="onSelected(null)">
    {{ 'common.none' | t }}
  </mat-option>

  <mat-option
    *ngFor="let option of options$ | async; trackBy: trackTeam"
    [value]="option.id"
    (onSelectionChange)="onSelected(option)"
  >
    {{ option.name }}
  </mat-option>
</mat-select>
